"use client";

// npm packages
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";

// components
import Button from "../Button";
import Icon from "../Icon";
import Text from "../Text";

// utils

const jobSearchResult = [
  {
    id: 1,
    jobName: "Product Manager, Commertial",
  },
  {
    id: 2,
    jobName: "Product Analyst",
  },
  {
    id: 3,
    jobName: "Product Designer",
  },
];

const searchData = [
  { id: 1, name: "Product Manager, Commertial", jobFound: "100" },
  { id: 2, name: "Product Analyst", jobFound: "100" },
  { id: 3, name: "Product Designer", jobFound: "100" },
];

const JobSearchModal = ({ onView, onClose }) => {
  const modalRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [openModal, setOpenModal] = useState(onView);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
        document.body.style.overflow = "hidden";
      }, 100);
    } else {
      setOpenModal(false);
      document.body.style.overflow = "";
    };

    return () => {
      document.body.style.overflow = "";
    };
  }, [onView]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      };
    };

    if (openModal) {
      document.addEventListener("mousedown", handleOutsideClick);
    };

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openModal]);

  const handleClose = (state, search) => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(state, search);
    }, 200);
  };

  const handleSearchInputChange = (event) => {
    let searchValue = event.target.value;
    searchValue.trim();

    if (searchValue !== "" || searchValue !== null) {
      setSearchInput(searchValue);
    };
  };

  const hightlightText = (text, term) => {
    if (!term) return text;

    const regex = new RegExp(`(${term})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === term.toLowerCase() ? (
        <span
          key={index}
          style={{
            backgroundColor: "#ffdd54",
            color: "#131C27",
            fontWeight: "700",
          }}
        >
          {part}
        </span>
      ) : (
        part
      ));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleClose(false, searchInput);
    };
  };

  return (
    <div
      className={classNames(
        "w-full h-full bg-black/50 flex justify-center items-center opacity-30 fixed bottom-full left-0 right-0 transition-opacity duration-100",
        { "!bottom-0 !opacity-100 !z-[500]": openModal }
      )}
    >
      <div
        ref={modalRef}
        className={classNames(
          "bg-white lg:w-full lg:max-w-[800px] px-20 pt-20 pb-[48px] lg:p-[32px] fixed lg:static opacity-50 lg:rounded-[24px] space-y-[20px] transition-all duration-[400ms] shadow-compare-bottom-action",
          { "w-full lg:w-auto h-full lg:h-auto mt-[210px] lg:mt-0 !opacity-100": openModal }
        )}
      >
        <Text
          type="sub_title"
          className="text-center !text-18 font-medium leading-28 tracking-[0.36px] mb-10 line-clamp-1"
        >
          Find the right job for you
        </Text>
        <div
          className="w-full max-w-[720px] h-[40px] lg:h-[48px] flex items-center justify-center bg-white p-0 lg:py-4 px-8 lg:px-12 border border-atelier rounded-[28px] gap-[12px] mb-24"
        >
          <Button type="link" className="flex items-center justify-center ml-4 !p-0">
            <Icon type="search" className="size-[24px] lg:size-[32px]" color={"#49525E"} />
          </Button>
          <input
            className="w-full border-none bg-transparent text-coarse-wool text-18 font-encode-sans font-medium leading-28 tracking-[0.36px] py-1 placeholder:text-lightslategray placeholder:text-14 lg:placeholder:text-18 placeholder:font-normal placeholder:font-encode-sans placeholder:leading-28 placeholder:tracking-[0.36px] outline-none focus:outline-none "
            type="text"
            name="search"
            value={searchInput}
            autoFocus={true}
            onKeyDown={handleKeyDown}
            onChange={(e) => handleSearchInputChange(e)}
            placeholder="Search for Jobs"
          />
          <Button
            type="link"
            className={classNames("invisible flex items-center justify-center ml-4 !p-0",
              { "!visible": searchInput !== "" }
            )}
            onClick={() => setSearchInput("")}
          >
            <Icon type="close" className="size-[32px]" color={"#49525E"} />
          </Button>
        </div>

        <div>
          {searchInput && searchInput.length >= 3 ? (
            searchData?.map((item, index) => {
              return (
                <React.Fragment key={item?.id}>
                  <div className="flex justify-between items-center py-12 pl-4 cursor-pointer">
                    <Button
                      type="link"
                      className="w-full flex justify-between items-center !p-0"
                      onClick={() => handleClose(false, item.name)}
                    >
                      <Text
                        type="sub_title"
                        className="!text-16 font-medium leading-20 tracking-[0.32px] line-clamp-1"
                      >
                        {hightlightText(item.name, searchInput)}
                      </Text>
                      <Icon type="angle-down" className="size-[32px] -rotate-90" color={"#49525E"} />
                    </Button>
                  </div>
                  <div className="border-b border-aquarelle-purple my-4"></div>
                </React.Fragment>
              )
            })
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default JobSearchModal;